import React from 'react';
import Link from 'next/link';
import Icon from '@common/assets';
import { RouteUrl } from '@utils/routeUtil';

import classnames from 'classnames/bind';
import styles from './preparation.module.scss';
const cx = classnames.bind(styles);

const InterviewPractice = () => {
  return (
    // 면접연습 영역
    <div className={cx('preparationListArea')}>
      <em className={cx('preparationTitle')}>면접연습</em>
      <ul className={cx('preparationList')}>
        <li className={cx('listItem')}>
          <Link href={RouteUrl.PASS_INTERVIEW} legacyBehavior>
            <a className={cx('link')} role="button">
              <div className={cx('icon')}>
                <Icon name="chatYellow" />
              </div>
              <div className={cx('infoArea')}>
                <div className={cx('infoTitle')}>기출 면접 연습</div>
                <p className={cx('infoDesc')}>
                  면접준비, 실전처럼 연습해보세요.
                  <br />
                  기업별 예상질문부터 면접연습까지 한 번에
                </p>
              </div>
            </a>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default InterviewPractice;
